import { useState, useEffect } from "react";
import {
  loadViewingPeriod,
  saveViewingPeriod,
  type ViewingPeriod,
} from "@/lib/periodStorageUtils";
import { formatPeriodDisplay } from "@/lib/subscriptionDateUtils";

export const useViewingPeriod = () => {
  const [currentPeriod, setCurrentPeriod] = useState<ViewingPeriod>(() =>
    loadViewingPeriod(),
  );

  // Persist currentPeriod changes to localStorage
  useEffect(() => {
    saveViewingPeriod(currentPeriod);
  }, [currentPeriod]);

  const getCurrentPeriodDisplay = () =>
    formatPeriodDisplay(currentPeriod.month, currentPeriod.year);

  const navigatePeriod = (direction: "prev" | "next") => {
    const newDate = new Date(currentPeriod.year, currentPeriod.month, 1);
    if (direction === "prev") {
      newDate.setMonth(newDate.getMonth() - 1);
    } else {
      newDate.setMonth(newDate.getMonth() + 1);
    }
    setCurrentPeriod({
      month: newDate.getMonth(),
      year: newDate.getFullYear(),
    });
  };

  const setToCurrentMonth = () => {
    const now = new Date();
    setCurrentPeriod({ month: now.getMonth(), year: now.getFullYear() });
  };

  const setToNextMonth = () => {
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    setCurrentPeriod({
      month: nextMonth.getMonth(),
      year: nextMonth.getFullYear(),
    });
  };

  return {
    currentPeriod,
    setCurrentPeriod,
    getCurrentPeriodDisplay,
    navigatePeriod,
    setToCurrentMonth,
    setToNextMonth,
  };
};
